import React from 'react';
import { GUIDE_ITEM_ROW } from '../../utils/guideItemRowLayout';

/**
 * Barra fija de captura rápida de productos (encima de la tabla de ítems).
 */
const QuickProductLineBar = ({
  onAdd,
  disabled = false,
  error = null,
  rowClassName = GUIDE_ITEM_ROW,
  defaultsSlot = null,
  children,
}) => (
  <div
    className="mb-4 rounded-lg border-2 border-dashed border-teal-300 bg-teal-50/60 p-3"
    data-enter-action-zone="quick-add"
  >
    <span className="mb-2 block text-xs font-semibold uppercase tracking-wide text-teal-800">
      Captura rápida
    </span>
    {defaultsSlot ? <div className="mb-3">{defaultsSlot}</div> : null}
    <div className={rowClassName}>
      {children}
    </div>
    {error && (
      <p className="mt-2 text-xs text-red-600">{error}</p>
    )}
    <div className="mt-3 flex justify-end">
      <button
        type="button"
        onClick={onAdd}
        disabled={disabled}
        className="shrink-0 rounded-lg bg-teal-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-teal-700 disabled:cursor-not-allowed disabled:opacity-50"
      >
        Agregar
      </button>
    </div>
  </div>
);

export default QuickProductLineBar;
